module.exports = __webpack_public_path__ + "assets/img/ner.d9cae2de.png";